import api from "./api";

/**
 * Döküman uçları (backend: /api/documents). Yanıtlar ApiResponse zarfında
 * (res.data.data).
 *
 * - PLATFORM dökümanları: ADMIN yükler, tüm salonlar görür/indirir.
 * - SALON dökümanları: MANAGER yükler, kendi salonundaki MANAGER/STAFF görür.
 */
export const documentService = {
  list: () => api.get("/documents"),
  limit: () => api.get("/documents/limit"),
  upload: (formData) =>
    api.post("/documents", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    }),
  update: (id, payload) => api.put(`/documents/${id}`, payload),
  remove: (id) => api.delete(`/documents/${id}`),
  /** Dosyayı blob olarak indirir; çağıran tarafı tarayıcıda kaydettirir. */
  download: (id) => api.get(`/documents/${id}/download`, { responseType: "blob" }),
};
